import React, { type CSSProperties, type FC } from 'react'

type Props = {
  style?: CSSProperties
  value: number | React.ReactNode
}

export const SuperscriptUI: FC<Props> = ({ value, ...props }) => (
  <sup className="top-0 ml-[0.15rem] text-[60%] !leading-none" {...props}>
    {value}
  </sup>
)
